export var PermissionEnum;
(function (PermissionEnum) {
    PermissionEnum["view_documents"] = "view_documents";
    PermissionEnum["create_documents"] = "create_documents";
    PermissionEnum["update_documents"] = "update_documents";
    PermissionEnum["delete_documents"] = "delete_documents";
    PermissionEnum["view_user"] = "view_user";
    PermissionEnum["create_user"] = "create_user";
    PermissionEnum["update_user"] = "update_user";
    PermissionEnum["delete_user"] = "delete_user";
    PermissionEnum["view_audit"] = "view_audit";
    PermissionEnum["create_audit"] = "create_audit";
    PermissionEnum["update_audit"] = "update_audit";
    PermissionEnum["delete_audit"] = "delete_audit";
    PermissionEnum["view_workflow"] = "view_workflow";
    PermissionEnum["create_workflow"] = "create_workflow";
    PermissionEnum["update_workflow"] = "update_workflow";
    PermissionEnum["delete_workflow"] = "delete_workflow";
    PermissionEnum["view_report"] = "view_report";
    PermissionEnum["create_report"] = "create_report";
    PermissionEnum["update_report"] = "update_report";
    PermissionEnum["delete_report"] = "delete_report";
    PermissionEnum["view_static"] = "view_static";
    PermissionEnum["create_static"] = "create_static";
    PermissionEnum["update_static"] = "update_static";
    PermissionEnum["delete_static"] = "delete_static";
    PermissionEnum["view_system"] = "view_system";
    PermissionEnum["create_system"] = "create_system";
    PermissionEnum["update_system"] = "update_system";
    PermissionEnum["delete_system"] = "delete_system";
})(PermissionEnum || (PermissionEnum = {}));
//# sourceMappingURL=permission-types.js.map